import { render, staticRenderFns } from "./SeasonForm.vue?vue&type=template&id=130464b8&"
import script from "./SeasonForm.vue?vue&type=script&lang=js&"
export * from "./SeasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SeasonForm.vue"
export default component.exports